import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface AddStarPointsInterface {
  date: string;
}

export const useGetDashboardStatsForEarnings = () => {
  const mutate = useMutation(({ date }: AddStarPointsInterface) => {
    return get(`/external-api/get_admin_monthly_stats`);
  });

  return mutate;
};

export default useGetDashboardStatsForEarnings;
